import { render, staticRenderFns } from "./editPaymentPool.vue?vue&type=template&id=6b6f945a&scoped=true"
import script from "./editPaymentPool.vue?vue&type=script&lang=js"
export * from "./editPaymentPool.vue?vue&type=script&lang=js"
import style0 from "./editPaymentPool.vue?vue&type=style&index=0&id=6b6f945a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f945a",
  null
  
)

export default component.exports